import { render, staticRenderFns } from "./NavigationBar.vue?vue&type=template&id=994a245a&scoped=true&"
import script from "./NavigationBar.vue?vue&type=script&lang=js&"
export * from "./NavigationBar.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/NavigationBar.css?vue&type=style&index=0&id=994a245a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994a245a",
  null
  
)

export default component.exports